// Static JSON-LD schemas for Midway Driving School
// These don't require GraphQL queries and are built at compile time

import { getSchemaHours, phoneNumber } from './businessHours'

const baseUrl = 'https://midwaydrivingschools.com'

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${baseUrl}/#organization`,
  name: 'Midway Driving School',
  alternateName: 'MDS',
  url: baseUrl,
  logo: `${baseUrl}/icons/icon-512x512.png`,
  description:
    'Midway Driving School – ESL/Nervous Adult and Home School Behind the Wheel Driving Lessons Serving the Twin Cities (Saint Paul, Minneapolis)',
  areaServed: [
    {
      '@type': 'City',
      name: 'Minneapolis',
      sameAs: 'https://en.wikipedia.org/wiki/Minneapolis'
    },
    {
      '@type': 'City',
      name: 'Saint Paul',
      sameAs: 'https://en.wikipedia.org/wiki/Saint_Paul,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Bloomington',
      sameAs: 'https://en.wikipedia.org/wiki/Bloomington,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Plymouth',
      sameAs: 'https://en.wikipedia.org/wiki/Plymouth,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Eagan',
      sameAs: 'https://en.wikipedia.org/wiki/Eagan,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Eden Prairie',
      sameAs: 'https://en.wikipedia.org/wiki/Eden_Prairie,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Maple Grove',
      sameAs: 'https://en.wikipedia.org/wiki/Maple_Grove,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Woodbury',
      sameAs: 'https://en.wikipedia.org/wiki/Woodbury,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Brooklyn Park',
      sameAs: 'https://en.wikipedia.org/wiki/Brooklyn_Park,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Minnetonka',
      sameAs: 'https://en.wikipedia.org/wiki/Minnetonka,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Edina',
      sameAs: 'https://en.wikipedia.org/wiki/Edina,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Roseville',
      sameAs: 'https://en.wikipedia.org/wiki/Roseville,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Coon Rapids',
      sameAs: 'https://en.wikipedia.org/wiki/Coon_Rapids,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Blaine',
      sameAs: 'https://en.wikipedia.org/wiki/Blaine,_Minnesota'
    },
    {
      '@type': 'City',
      name: 'Burnsville',
      sameAs: 'https://en.wikipedia.org/wiki/Burnsville,_Minnesota'
    }
  ],
  serviceType: [
    'Behind-the-wheel driving lessons',
    'Adult driver education',
    'ESL driver training',
    'English as second language driving instruction',
    'Nervous driver instruction',
    'Anxious adult driver training',
    'Home school driver education',
    'Homeschool behind-the-wheel training',
    'Minnesota road test preparation',
    'Defensive driving courses',
    'Winter driving instruction',
    'New adult driver training',
    'Immigrant driver education',
    'Senior driver refresher courses',
    'Parallel parking instruction',
    'Highway driving lessons',
    'City driving instruction'
  ],
  telephone: phoneNumber
}

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'DrivingSchool',
  '@id': `${baseUrl}/#localbusiness`,
  name: 'Midway Driving School',
  description:
    'Midway Driving School – ESL/Nervous Adult and Home School Behind the Wheel Driving Lessons Serving the Twin Cities (Saint Paul, Minneapolis)',
  url: baseUrl,
  logo: `${baseUrl}/icons/icon-512x512.png`,
  image: `${baseUrl}/icons/icon-512x512.png`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Twin Cities',
    addressRegion: 'MN',
    addressCountry: 'US'
  },
  areaServed: [
    {
      '@type': 'City',
      name: 'Minneapolis'
    },
    {
      '@type': 'City',
      name: 'Saint Paul'
    },
    {
      '@type': 'City',
      name: 'Bloomington'
    },
    {
      '@type': 'City',
      name: 'Plymouth'
    },
    {
      '@type': 'City',
      name: 'Eagan'
    },
    {
      '@type': 'City',
      name: 'Eden Prairie'
    },
    {
      '@type': 'City',
      name: 'Maple Grove'
    },
    {
      '@type': 'City',
      name: 'Woodbury'
    },
    {
      '@type': 'City',
      name: 'Brooklyn Park'
    },
    {
      '@type': 'City',
      name: 'Minnetonka'
    },
    {
      '@type': 'City',
      name: 'Edina'
    },
    {
      '@type': 'City',
      name: 'Roseville'
    },
    {
      '@type': 'City',
      name: 'Coon Rapids'
    },
    {
      '@type': 'City',
      name: 'Blaine'
    },
    {
      '@type': 'City',
      name: 'Burnsville'
    }
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Driving Lessons & Training Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Behind-the-wheel driving lessons',
          description:
            'Professional in-car driving instruction with certified instructors'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Adult driver education',
          description: 'Specialized training for adult learners and new drivers'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'ESL driver training',
          description:
            'English as second language driver instruction for immigrants and international students'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Nervous driver instruction',
          description:
            'Patient, supportive training designed specifically for anxious and nervous drivers'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Homeschool driver education',
          description: 'Behind-the-wheel training for homeschooled students'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Minnesota road test preparation',
          description:
            'Road test prep and practice for Minnesota DMV driving exam'
        }
      },
      {
        '@type': 'Offer',
        audience: {
          '@type': 'PeopleAudience',
          audienceType: 'Adult drivers'
        },
        itemOffered: {
          '@type': 'Service',
          name: 'Adult behind-the-wheel lessons',
          description:
            'Driving instruction specifically designed for adult learners, including those starting to drive later in life'
        }
      },
      {
        '@type': 'Offer',
        audience: {
          '@type': 'PeopleAudience',
          audienceType: 'ESL students'
        },
        itemOffered: {
          '@type': 'Service',
          name: 'ESL driving instruction',
          description:
            'Driving lessons for English as Second Language students with instructors experienced in working with limited English proficiency'
        }
      },
      {
        '@type': 'Offer',
        audience: {
          '@type': 'PeopleAudience',
          audienceType: 'Nervous drivers'
        },
        itemOffered: {
          '@type': 'Service',
          name: 'Anxiety-focused driving training',
          description:
            'Specialized instruction for anxious and nervous drivers with patient, confidence-building techniques'
        }
      }
    ]
  },
  telephone: phoneNumber,
  openingHoursSpecification: getSchemaHours('office')
}

// Website schema for homepage
export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${baseUrl}/#website`,
  url: baseUrl,
  name: 'Midway Driving School',
  description:
    'Midway Driving School – ESL/Nervous Adult and Home School Behind the Wheel Driving Lessons Serving the Twin Cities (Saint Paul, Minneapolis)',
  publisher: {
    '@id': `${baseUrl}/#organization`
  }
}
